import { useState, useEffect, useCallback } from "react";
import { followApi } from "@/api/social";

export function useFollow(companyId: string | undefined) {
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [followedIds, setFollowedIds] = useState<string[]>([]);

  const loadFollowed = useCallback(async () => {
    try {
      const res = await followApi.list();
      setFollowedIds(res.company_ids || []);
      if (companyId) {
        setIsFollowing((res.company_ids || []).includes(companyId));
      }
    } catch {
      // ignore
    }
  }, [companyId]);

  useEffect(() => {
    loadFollowed();
  }, [loadFollowed]);

  const toggle = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      if (isFollowing) {
        await followApi.unfollow(companyId);
        setIsFollowing(false);
        setFollowedIds((prev) => prev.filter((id) => id !== companyId));
      } else {
        await followApi.follow(companyId);
        setIsFollowing(true);
        setFollowedIds((prev) => [...prev, companyId]);
      }
    } catch (e) {
      console.error("[Follow] toggle failed:", e);
    } finally {
      setLoading(false);
    }
  }, [companyId, isFollowing]);

  return { isFollowing, loading, toggle, followedIds, reload: loadFollowed };
}
